export default __webpack_public_path__ + "static/media/work_black_2.732ad018.svg";